import { fetchOk } from '@atlassian/mpac-fetch-wrapper';
export const getCloudMigrationInfo = (mpacBaseUrl, appKey) => fetchOk("".concat(mpacBaseUrl, "/rest/2/addons/").concat(appKey, "/migration")).then(response => response.json()).catch(error => {
  if (error.status === 404) return null;
  throw error;
});
export const getBulkCloudMigrationInfo = (mpacBaseUrl, addons) => fetchOk("".concat(mpacBaseUrl, "/rest/2/addons/migration/bulkfetch"), {
  method: 'POST',
  body: JSON.stringify(addons),
  headers: {
    'Content-Type': 'application/json'
  }
}).then(response => response.json()).catch(error => {
  throw error;
});
export const updateMigrationInfo = (mpacBaseUrl, appKey, body) => fetchOk("".concat(mpacBaseUrl, "/rest/2/addons/").concat(appKey, "/migration"), {
  method: 'PUT',
  body: JSON.stringify(body),
  headers: {
    'Content-Type': 'application/json'
  }
}).then(response => response.json()).catch(error => {
  throw error;
});